import { PaginatedResponse } from '@/utils/types';
import { AxiosResponse } from 'axios';
import { AntennaType, PvPanelType } from './deploy-device/types';
import { DeploymentType } from '../measurement-group/field-report/types';
import { Series } from '../measurement-group/types';

export enum PacketSortableColumn {
	ID = 'ID',
	REALTIME = 'REALTIME'
}

export type RecentPacketsResponse = PaginatedResponse<{
	realTime: string;
	dataPacketNumber: number;
}>;

export enum VitalType {
	LithiumVoltage = 'LITHIUM_VOLTAGE',
	AlkalineVoltage = 'ALKALINE_VOLTAGE',
	SolarVoltage = 'SOLAR_VOLTAGE',
	GSMSignal = 'GSM_SIGNAL',
	SatelliteSignal = 'SATELLITE_SIGNAL',
	Humidity = 'HUMIDITY'
}

export type DeviceResponse = {
	id: number;
	site: string | null;
	siteId: number | null;
	landowner: string | null;
	longitude: number | null;
	latitude: number | null;
};

export type VitalsResponse = {
	type: VitalType;
	realTime: string;
	lastValue: number;
	dataPacketNumber: number;
};

export type DeviceMetadata = {
	traceType: string | null;
	traceSite: string | null;
	enclosure: string | null;
	antennaType: string | null;
	pvPanelType: string | null;
};

export type DeviceStats = {
	performance12Hour: number;
	lastPacket: string | null;
	firmware: string | null;
	interval: string | null;
	modem: string | null;
};

type DistributionValue = {
	value: number;
	label: string;
};

type Distribution = {
	name: string;
	data: DistributionValue[];
};

export type DashboardInfoResponse = {
	slowMonitoringSeries: Series[];
	metadata: DeviceMetadata;
	stats: DeviceStats;
	gainDistribution: Distribution[];
};

export type DeviceLoaderResponse = {
	recentData: AxiosResponse<RecentPacketsResponse>;
	slowMonitoring: AxiosResponse<VitalsResponse[]>;
	devices: AxiosResponse<DeviceResponse[]>;
	antennas: Promise<AxiosResponse<AntennaType[]>>;
	pvPanels: Promise<AxiosResponse<PvPanelType[]>>;
	deploymentTypes: Promise<AxiosResponse<DeploymentType[]>>;
};
